import apiInternal from './servers/apiInternal';

export interface DatateamReprocessResponse {
  success: boolean;
  data: Array<{
    id: string;
    idDemanda: string;
    status?: string;
    message: string;
  }>;
}

const datateamReprocess = {
  reprocess: async ({ 
    demandIds, 
    environment, 
    idArtifact 
  }: { 
    demandIds: string[]; 
    environment: string; 
    idArtifact?: number;
  }): Promise<DatateamReprocessResponse> => {
    const res = await apiInternal.post(`/datateam/reprocessar`, {
      demandIds,
      environment,
      idArtifact: idArtifact ?? 0, // idArtifact sempre é 0 no supreq
    });
    // O backend retorna { success: true, data: [...] }
    // Garantimos que sempre retornamos no formato esperado
    if (res.data && res.data.success !== undefined && res.data.data) {
      return res.data;
    }
    // Fallback caso a resposta venha em formato diferente
    return {
      success: true,
      data: Array.isArray(res.data) ? res.data : [],
    };
  },
};

export default datateamReprocess;

